



















import Vue from 'vue';

import AtomHeading from '@/components/atoms/AtomHeading.vue';

export default Vue.extend({
  name: 'HeadingLeft',
  props: {
    label: {
      type: String,
      required: true,
    },
    sizeClass: {
      type: String,
      required: true,
    },
    iconClass: {
      type: String,
    },
  },
  components: {
    AtomHeading,
  },
});
